<template>
  <v-container>
    <v-row dense>
       <v-col cols="12" class="d-flex justify-center">
        <div class="text-h4 font-weight-bold"><v-icon large color="#DAA520">mdi-factory</v-icon>Producción y Venta Agroindustrial</div>
      </v-col>
      <v-col cols="12" class="pb-3">
        <div class="text-h6">1. Agrega una nueva Producción</div>
        <div class="text-h7">Presiona el botón para crear una nueva producción</div>
      </v-col>
      <v-col v-if="user_can.add" cols="12">
        <v-btn router to="/ru/agroindustria" depressed class="primary">
         <span style="font-size: 30px">🧴📦</span>
          <v-icon left>mdi-plus</v-icon>
          Agrega una Nueva
        </v-btn>
      </v-col>
      <v-col cols="12" class="tt">
        <div class="text-h6"><v-icon large color="amber darken-2">mdi-package-variant</v-icon> 2. Mis producciones y Ventas</div>
        <div class="text-h8">Presiona la producción agroindustrial para agregar Ventas, producción o modificarlas</div>
      </v-col>
      <!-- Fila de espaciado -->
      <v-col cols="12" class="py-5"></v-col>
       <!-- Puedes ajustar py-5 a py-3 o py-2 según el espacio que prefieras -->
      <!-- Mensaje si no hay fincas -->
      <v-col v-if="Object.keys(agroindustrias).length === 0" cols="12">
        <div class="text-body-1 text-center font-italic">
          Aún no tienes ninguna producción agroindustrial 
        </div>
      </v-col>
      <!-- listado de actividades agroindustriales en el almacenamiento local -->
      <v-col cols="12" class="lista">
        <v-list three-line>
          <template v-for="agroindustria in agroindustrias">
            <form-card
              :key="agroindustria.id"
              :top-text="`Finca • ${getNombreDeFinca(agroindustria.id_finca)}`"
              :top-right-text="agroindustria.fecha"
              :middle-text="agroindustria.descripcion"
              :bottom-text="`Ciclo ${agroindustria.ciclo}`"
              :bottom-right-text="producerDescription(agroindustria.productor)"
              :sincronized="agroindustria.sincronizado"
              @click="traerRegistroYNavegar(agroindustria)"
            />
          </template>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { producerDescription } from '@/utilidades'

export default {
  name: 'Cosechas',
  computed: {
    ...mapState('registros', ['agroindustrias']),
    ...mapGetters('registros', ['getNombreDeFinca']),
    user_can() {
      return this.$store.getters['auth/userCan'](this.$route.path)
    },
  },
  mounted() {
    this.$store.commit('ui/updateToolbar', 'Agroindustrias')
  },
  methods: {
    producerDescription,
    async traerRegistroYNavegar(registro) {
      if (registro.sincronizado === true) {
        await this.$store.dispatch('registros/getAgroindustria', {
          id: registro.id,
        })
      }
      this.$router.push(`/ru/agroindustria/${registro.id}`)
    },
  },
}
</script>
<style>
  .tt {
    margin-top: 40px;
    margin-bottom: -20px;
  }
  .lista {
    margin-top: 20px;
  }
</style>
